import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import moment from "moment";
import "moment-timezone";
import { useEffect, useRef } from "react";
import "react-multi-carousel/lib/styles.css";
import { CustomLeftArrow, CustomRightArrow } from "../../Shared/components/CardLayout/CustomComponents";
import Carousel from "../../Shared/components/ReactMultiCarousel";
import { ORDER_STATUS } from "../../Shared/utils/constants";
import "../utils/myMealsCSS.css";
import { MealDay } from "./MealDay";
const NUM_DAYS_MOBILE = 2;
const NUM_DAYS_TABLET = 3;
const NUM_DAYS_DESKTOP = 5;
/**
 * Finds the index of the selected day in the days array,
 * which is used to set the initial slide of the carousel.
 * @param days
 * @param selectedDay
 * @returns
 */
const getInitialSlide = (days, selectedDay) => days.findIndex((day) => moment(day.DateFormatted).isSame(selectedDay.DateFormatted, "day"));
/**
 * Checks if a specific date property of a day object is present in the skippedDays array.
 * @param skippedDays - Array of objects containing customerDate properties.
 * @param day - The day object containing the date property to check.
 * @param dateProperty - The property of the day object to compare (e.g., 'DateFormatted' or 'ShipDate').
 * @returns boolean - Returns true if the date is found in skippedDays, otherwise false.
 */
const isDateSkipped = (skippedDays, day, dateProperty) => {
    return skippedDays === null || skippedDays === void 0 ? void 0 : skippedDays.some((skipDay) => moment(skipDay.customerDate).utc().isSame(moment(day[dateProperty]).utc(), "day"));
};
export const MealDaySection_Carousel = ({ days, selectedDay, skippedDays, selectedFutureOrder, onMealDayClick, numDaysPerSlide, showDayIcons, mealQuantitySelectionMode, restrictAddRemoveDays, orderHasFutureStatus, }) => {
    // We need to use a ref to gain access to the goToSlide method in order
    // to set the initial slide when the component first renders.
    const carouselRef = useRef(null);
    const theme = useTheme();
    useEffect(() => {
        if (carouselRef.current) {
            const initialSlide = getInitialSlide(days, selectedDay);
            carouselRef.current.goToSlide(initialSlide);
        }
    }, []);
    return (_jsx(Carousel, Object.assign({ ref: carouselRef, renderButtonGroupOutside: true, 
        // @ts-ignore -- There is an error with the additionalTransform typing.
        additionalTransform: 0, arrows: days.length > numDaysPerSlide, renderArrowsWhenDisabled: false, customLeftArrow: _jsx(CustomLeftArrow, { arrowBgColor: theme.palette.common.white, borderColor: grey[700], arrowColor: grey[700], sx: { paddingBottom: 0, left: 8, top: "40%" } }), customRightArrow: _jsx(CustomRightArrow, { arrowBgColor: theme.palette.common.white, borderColor: grey[700], arrowColor: grey[700], sx: { paddingBottom: 0, right: 8, top: "40%" } }), autoPlaySpeed: 3000, centerMode: false, containerClass: days.length < numDaysPerSlide ? "carousel centered meal-days" : "meal-days", dotListClass: "", draggable: true, focusOnSelect: false, infinite: false, itemClass: "", keyBoardControl: true, minimumTouchDrag: 80, pauseOnHover: true, renderDotsOutside: false, responsive: {
            desktop: {
                breakpoint: {
                    max: 3000,
                    min: theme.breakpoints.values.md,
                },
                items: NUM_DAYS_DESKTOP,
                slidesToSlide: NUM_DAYS_DESKTOP,
            },
            mobile: {
                breakpoint: {
                    max: theme.breakpoints.values.sm,
                    min: 0,
                },
                items: NUM_DAYS_MOBILE,
                slidesToSlide: NUM_DAYS_MOBILE,
            },
            tablet: {
                breakpoint: {
                    max: theme.breakpoints.values.md,
                    min: theme.breakpoints.values.sm,
                },
                items: NUM_DAYS_TABLET,
                slidesToSlide: NUM_DAYS_TABLET,
            },
        }, rewind: false, rewindWithAnimation: false, rtl: false, shouldResetAutoplay: true, showDots: false, sliderClass: "", slidesToSlide: 1, swipeable: true }, { children: days &&
            days.map((day) => {
                const isDaySkipped = isDateSkipped(skippedDays, day, "DateFormatted");
                const isShipDaySkipped = isDateSkipped(skippedDays, day, "ShipDate");
                return (_jsx(MealDay, { day: day, isSkipped: isDaySkipped || isShipDaySkipped, isFutureDay: (selectedFutureOrder && selectedFutureOrder.OrderStatus === ORDER_STATUS.FUTURE) || orderHasFutureStatus, onMealDayClick: onMealDayClick, myMealsConfig: {
                        ShowDayIcons: showDayIcons,
                        MealQuantitySelectionMode: mealQuantitySelectionMode,
                        RestrictAddRemoveDays: restrictAddRemoveDays,
                    }, formattedDateOfSelectedDay: selectedDay.DateFormatted }, day.DateFormatted));
            }) })));
};
